import ModalController from './ModalController';

export default ModalController;
